/**
 * 게시물 등록
 */
import React, { Component } from 'react';
import { Navbar, Form, Button } from 'react-bootstrap';
import { udfAutoLogin, url, udfNoneLoading, udfInlineLoading, openAlert } from '../../common/common'
import $ from 'jquery';
import loader from '../../imgs/ajax-loader.gif';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';
import SideMenuCmp from './SideMenuCmp';
import { dropByCacheKey } from 'react-router-cache-route'

class NoticeRegistCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validated: false,

      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      isLoggedIn: null,
      articleInfo: {},
      textAreaValue: '',
      usrInfo: null,
    }
  }

  componentDidMount = () => {
    // 자동 로그인 체크
    udfAutoLogin(this).then((data) => {
      if (data !== null && data.userSe === 'STDT') {
        this.props.history.push('/stdt/ruleList');
      } else if (data !== null && data.userSe === 'USR') {
        this.setState({ usrInfo: data });
        if (this.props.match.params.nttId !== '0') this.udfSelectArticle();
      } else {
        this.props.history.push('/');
      }
    });
  }

  udfSelectArticle = () => {
    if (!this.state.usrInfo) return;
    udfInlineLoading();

    let that = this;

    $.ajax({
      url: url + '/cop/bbs/selectBoardArticle.do',
      type: 'GET',
      dataType: 'jsonp',
      data: { isMobile: 'Y', bbsId: that.props.match.params.bbsId, nttId: that.props.match.params.nttId },
      success: function (data) {
        udfNoneLoading();

        if (!data.success)
          that.componentDidMount();
        else {
          if (data.list !== undefined && data.list !== null) {
            that.setState({
              isLoggedIn: true,
              articleInfo: data.list[0],
              textAreaValue: data.list[0].nttCn
            });
          }
        }
      },
      error: function (jqXHR, status, error) {
        udfNoneLoading();
        that.componentDidMount();
      }
    });
  }

  // form submit
  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity()) {
      let that = this;
      $.ajax({
        url: url + (this.props.match.params.nttId === '0' ? '/cop/bbs/insertBoardArticleMobile.do' : '/cop/bbs/updateBoardArticleMobile.do'),
        type: 'GET',
        dataType: 'jsonp',
        data: {
          isMobile: 'Y',
          bbsId: that.props.match.params.bbsId,
          nttId: that.props.match.params.nttId,
          ntceBgnde: '10000101',
          ntceEndde: '99991231',
          ntcrNm: 'dummy',
          password: 'dummy',
          authFlag: 'Y',
          nttSj: $('#nttSj').val(),
          nttCn: $('#nttCn').val()
        },
        success: function (data) {
          udfNoneLoading();

          if (!data.success)
            that.componentDidMount();
          else {
            if (data.result) {
              dropByCacheKey('qnaCachce');
              that.props.history.go(-1);
            } else
              openAlert(that, '오류가 발생했습니다.');
          }
        },
        error: function (jqXHR, status, error) {
          udfNoneLoading();
          that.componentDidMount();
        }
      });
    }
    this.setState({ validated: true });
  }

  onChangeText = (e) => {
    this.setState({ textAreaValue: e.target.value });
  }

  render() {
    return (
      <>
        <div className='wrap-loading d-none'>
          <img src={loader} alt='로딩 이미지' />
        </div>

        {/* header */}
        <Navbar fixed='top' className='title'>
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          {this.props.match.params.bbsId === 'BBSMSTR_000000000001' ? '공지사항' : (this.props.match.params.bbsId === 'BBSMSTR_000000000002' ? '학교게시물' : '1:1상담')} 등록
          <SideMenuCmp
            history={this.props.history}
            usrInfo={this.state.usrInfo}
            alertShow={this.state.alertShow}
            alertMessage={this.state.alertMessage}
            alertClickOk={this.state.alertClickOk}
            alertClickYes={this.state.alertClickYes}
            alertClickNo={this.state.alertClickNo}
          />
        </Navbar>

        <div className='container-fluid' style={{ marginTop: '4rem' }}>
          <Form
            noValidate
            validated={this.state.validated}
            onSubmit={e => this.handleSubmit(e)}
          >
            <Form.Group controlId='nttSj'>
              <Form.Label>제목</Form.Label>
              <Form.Control
                type='text'
                aria-describedby='nttSj'
                required
                defaultValue={this.state.articleInfo.nttSj}
              />
              <Form.Control.Feedback type='invalid'>
                제목을 입력해 주세요.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId='nttCn'>
              <Form.Label>내용</Form.Label>
              <Form.Control
                as='textarea'
                rows='4'
                aria-describedby='nttCn'
                required
                value={this.state.textAreaValue} onChange={this.onChangeText}
              />
              <Form.Control.Feedback type='invalid'>
                내용을 입력해 주세요.
              </Form.Control.Feedback>
            </Form.Group>

            <Button type='submit' variant='secondary' className='col p-3'>저장</Button>

          </Form>
        </div>

      </>
    );
  }
}

export default NoticeRegistCmp;